import { alpha } from '@mui/material/styles';

const OVERLAY_SHADOW_OPACITY = 0.7;

const getOverlayShadow = ({ palette }) =>
  `0 1px 4px ${alpha(palette.common.black, OVERLAY_SHADOW_OPACITY)}`;

export const getRootStyles = isOverlay => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  width: '100%',
  padding: ({ spacing }) => spacing(1, 2),
  ...(isOverlay
    ? { backgroundColor: 'transparent' }
    : {
        borderTop: ({ palette }) => `1px solid ${palette.divider}`,
        backgroundColor: ({ palette }) => palette.background.paper,
      }),
});

export const identityStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 1,
};

export const getIdentityTextSx = isOverlay => (isOverlay ? { textShadow: getOverlayShadow } : {});

export const getPoweredByStyles = isOverlay => {
  const linkColor = ({ palette }) =>
    `${isOverlay ? palette.common.white : palette.text.secondary} !important`;

  return {
    whiteSpace: 'nowrap',
    color: linkColor,
    textDecoration: 'none',
    ...(isOverlay ? { textShadow: getOverlayShadow } : {}),
    '&:link': { color: linkColor },
    '&:visited': { color: linkColor },
    '&:active': { color: linkColor },
    '&:hover': {
      color: linkColor,
      textDecoration: 'underline',
    },
  };
};
